import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of, shareReplay, tap, throwError } from 'rxjs';

import { TemplateBusca } from '../model/template/template-busca.model';
import { TemplatesChatPagina } from '../model/template/templates-chat-pagina.model';
import { AuthService } from './auth.service';
import { TemplateMensagemService } from './template-mensagem.service';
import { TAMANHO_PAGINA_TEMPLATES_CHAT, VALIDADE_PRIMEIRA_PAGINA_TEMPLATES_MS } from '../util/templates-chat.constantes';

@Injectable({ providedIn: 'root' })
export class TemplatesChatService {
  private primeiraPagina: TemplatesChatPagina | null = null;
  private primeiraPaginaEm = 0;
  private readonly detalhes = new Map<number, Observable<TemplateBusca>>();

  private readonly templateMensagemService = inject(TemplateMensagemService);
  private readonly authService = inject(AuthService);

  preCarregarPrimeiraPagina(forcar = false): void {
    if (forcar) this.primeiraPaginaEm = 0;
    this.buscarPagina('', 0).subscribe({ error: () => {} });
  }

  primeiraPaginaEmCache(): TemplatesChatPagina | null {
    return this.primeiraPaginaValida() ? this.primeiraPagina : null;
  }

  buscarPagina(busca: string, pagina: number): Observable<TemplatesChatPagina> {
    const termo = busca.trim();
    const ehPrimeira = !termo && pagina === 0;
    if (ehPrimeira && this.primeiraPaginaValida()) return of(this.primeiraPagina!);

    const perfil = this.authService.getUsuarioLogadoClariBot()?.perfil ?? 0;
    return this.templateMensagemService.buscarResumoTemplatesChat(perfil, pagina, TAMANHO_PAGINA_TEMPLATES_CHAT, termo).pipe(
      tap(resultado => {
        if (!ehPrimeira) return;
        this.primeiraPagina = resultado;
        this.primeiraPaginaEm = Date.now();
        this.detalhes.clear();
      })
    );
  }

  detalhe(templateId: number): Observable<TemplateBusca> {
    let detalhe$ = this.detalhes.get(templateId);
    if (!detalhe$) {
      detalhe$ = this.templateMensagemService.buscarTemplatePorId(templateId).pipe(
        catchError(erro => {
          this.detalhes.delete(templateId);
          return throwError(() => erro);
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );
      this.detalhes.set(templateId, detalhe$);
    }
    return detalhe$;
  }

  preCarregar(templateId: number): void {
    this.detalhe(templateId).subscribe({ error: () => {} });
  }

  private primeiraPaginaValida(): boolean {
    return !!this.primeiraPagina && Date.now() - this.primeiraPaginaEm < VALIDADE_PRIMEIRA_PAGINA_TEMPLATES_MS;
  }
}
